import { webMediaRecorder } from './start-web-recording.js';

/**
 * Pause web recording
 * @returns {Promise<void>}
 */
export const pauseWebRecording = async () => {
  if (!webMediaRecorder) {
    throw new Error('No web recording in progress');
  }

  if (webMediaRecorder.state === 'recording') {
    webMediaRecorder.pause();
    console.log('Web recording paused');
  } else {
    throw new Error('Recording is not active, cannot pause');
  }
};
